import Link from "next/link";

import styles from "./BlogCategoryButton.module.css";

function BlogCategoryButton({ slug, categoryTitle, onClick, review }) {
  if (review)
    return (
      <div className={styles.item}>
        <Link href="/reviews/" scroll={false}>

          <button type="button" className={styles.button} onClick={onClick}>
            Album Reviews
          </button>

        </Link>
      </div>
    );

  return (
    <div className={styles.item}>
      <Link href={`/blog/${slug}/`} scroll={false}>

        <button type="button" className={styles.button} onClick={onClick}>
          {categoryTitle}
        </button>

      </Link>
    </div>
  );
}

export default BlogCategoryButton;
